<template>
	<input type="hidden" value="">
</template>
<script>
	export default {
		props: [
			'id',
			'label',
			'value',
			'error',
			'errorMessages',
		],
	}
</script>